import { render, staticRenderFns } from "./ReceivershipApplicationDetails.vue?vue&type=template&id=afa8f0dc&scoped=true&"
import script from "./ReceivershipApplicationDetails.vue?vue&type=script&lang=js&"
export * from "./ReceivershipApplicationDetails.vue?vue&type=script&lang=js&"
import style0 from "./ReceivershipApplicationDetails.vue?vue&type=style&index=0&id=afa8f0dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa8f0dc",
  null
  
)

export default component.exports